import React from 'react';
import styled from 'styled-components';
import ArticleCard from './ArticleCard';
import { ContentfulArticle } from './Blog';

interface ArticlesContainerProps {
  articles: ContentfulArticle[];
  blogUrl?: string;
}

const ArticlesContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: 16px;
  padding-left: 0;
  padding-right: 0;
  width: 100%;
  margin-right: auto;
   margin-left: auto;
`;

const ArticlesContainer: React.FC<ArticlesContainerProps> = ({ articles, blogUrl }) => {
  return (
    <ArticlesContainerWrapper>
      {articles.map((article, index) => (
        <ArticleCard key={index} article={article} blogUrl={blogUrl} />
      ))}
    </ArticlesContainerWrapper>
  );
};

export default ArticlesContainer;